export const LABELS_TABLE_LABELS = {
	COLUMN_KEY: 'Key',
	COLUMN_DISPLAY_NAME: 'Key Display Name',
	COLUMN_TYPE: 'Label Type',
	COLUMN_VALUES: 'Values',
	COLUMN_ACTIONS: 'Actions',
	CREATE_BUTTON: 'Create Label',
	EDIT_ACTION: 'Edit',
	EMPTY_STATE: 'No labels found',
	TABLE_TITLE: 'Labels',
	TABLE_CAPTION: 'Labels management table',
	VALUES_MODAL_CLOSE: 'Close',
	VALUES_MODAL_TITLE: (key: string): string => `All values for "${key}"`
} as const;
